<template>
  <b-card class="drip-card">
    <slot />
  </b-card>
</template>
<script>
export default {
  props: ['cardClass']
}
</script>
<style lang="scss">
@import '../../../assets/scss/variables';

.drip-card {
  margin-bottom: 0;
  &.card {
    border: $drip-card-border;
    box-shadow: $drip-card-shadow;
    .card-body {
      padding: 0 15px;
    }
  }
}
</style>
